import { render, staticRenderFns } from "./quiz-results.html?vue&type=template&id=af32f640&scoped=true&"
import script from "./quiz-results.vue?vue&type=script&lang=js&"
export * from "./quiz-results.vue?vue&type=script&lang=js&"
import style0 from "./quiz-results.css?vue&type=style&index=0&id=af32f640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af32f640",
  null
  
)

export default component.exports